// extracted by mini-css-extract-plugin
export default {"modal":"_25ghTGohN5CzralyZawhxM"};